import React, { Component } from 'react'
import PropTypes from 'prop-types'

const timeClass = ({
  selectionClassName,
  highlightSpace,
  highlighted,
  isSelected
}) => {
  const classes = []

  if (isSelected) {
    classes.push(selectionClassName)
  }

  if (highlightSpace) {
    classes.push('highlight')
  }

  if (!isSelected && !highlighted) {
    classes.push('word-time')
  }

  return classes.join(' ')
}

const TranscriptWord = ({
  highlighted,
  highlightSpace,
  isSelected,
  timestamp,
  word,
  selectionClassName
}) => (
  <time
    data={timestamp}
    className={timeClass({
      selectionClassName,
      highlightSpace,
      highlighted,
      isSelected
    })}
  >
    {['.', '!', '?'].includes(word) ? '' : ' '}
    {word.startsWith('\n') && <br />}
    <span className={highlighted && !highlightSpace ? 'highlight' : ''}>
      {word.trim()}
    </span>
  </time>
)

TranscriptWord.propTypes = {
  highlighted: PropTypes.bool,
  highlightSpace: PropTypes.bool,
  isSelected: PropTypes.bool,
  selectionClassName: PropTypes.string,
  timestamp: PropTypes.number,
  word: PropTypes.string
}

export default TranscriptWord



// WEBPACK FOOTER //
// ../src/components/TranscriptWord.js